import React from "react";
import { ErrorLabel } from "./field-error.styles";

const FieldError = ({ message }: { message: string }): JSX.Element => {
  return <ErrorLabel>{message}</ErrorLabel>;
};

export { FieldError };
